export default async function apiFetch(
  path: string,
  args: {method: string; body?: string} =
  {
    method: 'GET',
  },
) {
  try {
    const response = await fetch(`${process.env.VUE_APP_API}${path}`, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      mode: 'cors',
      ...args,
    });
    const data = await response.json();

    return data;
  } catch (response) {
    throw new Error(response.statusText);
  }
}
